<template>
    <div>
        <div class="row">
            <div class="col">
                <h2 v-html="task.question" />
            </div>
        </div>
        <div class="mx-auto" id="mdiv" style="background-color:lightgray;height:300px; width:700px"></div>
    </div>
</template>
<script>
import MatchImage from '../Utils/matchimage';
import {map} from "lodash";

export default {
    props: {
       task: {
           type: Object,
           required: true,
       },
        value: {
           type: Object,
           required: true,
        }
    },
    watch: {
        form: {
            deep: true,
            handler () {
                this.$emit('input', this.form);
            }
        }
    },
    data() {
        return {
            form: {
                task_id: this.task.id,
                images: [],
            }
        }
    },
    mounted() {
        let main_gallery = this.task.taskable.image_gallery.map(function (gallery, index) {
            return `${gallery.main_image}`;
        }).join(',');

        let sub_gallery = this.task.taskable.image_gallery.map(function (gallery, index) {
            return `${gallery.pair_image}`;
        }).join(',');

        MatchImage.forceCheck = true;
        MatchImage.go(main_gallery, sub_gallery, 'mdiv', 'bottom_random=true; horizontal=yes')

        document.addEventListener('match', (e) => {
            this.form.images = map(e.detail.images, (image) => {
                return map(image, (item) => {
                    return {
                        ctrX: item.ctrX,
                        ctrY: item.ctrY,
                        gotit: item.gotit,
                        matchConnect: item.matchConnect,
                        seq: item.seq,
                        src: item.src,
                        status: item.status,
                    }
                });
            });
        })

        this.$emit('input', this.form);
    }
}
</script>
